import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { DateService } from '@app/services';

/**
 * Transforms a UTC date data to a date in the local timezone
 */
@Pipe({
    name: "localDate",
    standalone: true
})
export class LocalDatePipe implements PipeTransform {
  private readonly _componentName = 'LocalDatePipe';

  constructor(private datePipe: DatePipe, private dateHelper: DateService) {}

  transform(value: any, ...args: any[]): any {
    // console.log(`${this._componentName}.transform value=`, value);
    // console.log(`${this._componentName}.args value=`, args);
    if (!value) {
      return null;
    }

    let format = 'short';

    if (args && args.length > 0) {
      format = args[0];
    }

    const localDate = this.dateHelper.convertUTCDateToLocalDate(value);

    return this.datePipe.transform(localDate, format);
  }
}
